import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLOCKS } from '@contentful/rich-text-types';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useRichText } from '../../../utils/richText';
import { CarouselBannerContent } from './styles';
const ScrollingBannerBodyOptions = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return _jsx("div", { children: children });
        },
    },
};
const ScrollingBannerHeader = (props) => {
    const { title, descriptionText } = props;
    return (_jsxs(CarouselBannerContent, { children: [_jsx(Typography.Title, { level: 2, elementTheme: "h3", children: title }), _jsx(Typography, { elementTheme: "body1", children: useRichText(descriptionText, ScrollingBannerBodyOptions) })] }));
};
export default ScrollingBannerHeader;
